module.exports = __webpack_public_path__ + "img/mastecard-maestro@compress-h37.1dbd81e4.png";